module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "drop",
    on: {
      "dragover": function($event) {
        $event.preventDefault();
      },
      "drop": _vm.onDrop
    }
  }, [(!_vm.value) ? _c('label', {
    staticClass: "btn display-inline"
  }, [_vm._v("\n            PRZECIĄGNIJ I UPUŚĆ, LUB\n            "), _c('input', {
    attrs: {
      "type": "file",
      "name": "value"
    },
    on: {
      "change": _vm.onChange
    }
  })]) : _c('div', {
    staticClass: "hidden",
    class: {
      'value': true
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.value) + "\n            ")]), _vm._v(" "), (_vm.value) ? _c('el-button', {
    staticClass: "remove-button",
    attrs: {
      "size": "mini",
      "icon": "el-icon-delete",
      "type": "danger",
      "title": "Usuń plik"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeFile($event)
      }
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361528ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileInputComponent.vue
// module id = 739
// module chunks = 0